import { ICON_MAP, IconMessage } from '@act/storybook';

type NoDataMessageProps = {
  message: string;
  subMessage?: string;
  iconName?: keyof typeof ICON_MAP;
};

const NoDataMessage = ({
  message,
  subMessage,
  iconName,
}: NoDataMessageProps) => {
  return (
    <IconMessage
      message={message}
      subMessage={subMessage}
      iconName={iconName || 'Prohibit'}
      iconColor="primary"
    />
  );
};

export default NoDataMessage;
